// extracted by mini-css-extract-plugin
module.exports = {"clientInfoFormWrapper":"ClientsForm_clientInfoFormWrapper__2j59I","title":"ClientsForm_title__3Rt1r","addBtn":"ClientsForm_addBtn__2hORK"};